import React from 'react'
import PropTypes from 'prop-types'

const LayerDropdown = ({
    categories,
    layers,
    index,
    removeLayer,
    lyr,
    errorLayers,
    setErrorLayers,
    setSelected,
    active
}) => {
    const onChange = e => {
        const newLayers = errorLayers
        newLayers[index].layer = e
        setErrorLayers(newLayers)
        setSelected(e)
    }

    return (
        <div className="error-layer-dropdown">
            {lyr.layer === 'None' ? (
                <select
                    name="layers"
                    id="layers"
                    className="select dropdown"
                    onChange={e => onChange(e.target.value)}
                    value={lyr.layer}
                >
                    <option value="None" disabled>
                        Select a layer to add an issue ({index})
                    </option>

                    {categories.map(cat => {
                        const { label } = cat

                        const categoryLabel = (
                            <option value={label ? label : cat} key={Math.random()} disabled>
                                ---{label ? label : cat}---
                            </option>
                        )
                        return (
                            <React.Fragment key={Math.random()}>
                                {categoryLabel}
                                {layers.flat().map(layerDetails => {
                                    const fields = layerDetails.fields?.flat()
                                    const { name, label, category } = layerDetails

                                    // Screen Layers
                                    if (active === 'screen' && cat.label === label) {
                                        return (
                                            <React.Fragment key={Math.random()}>
                                                {fields.map(field => {
                                                    return (
                                                        <option value={field.label} key={Math.random()}>
                                                            {field.label}
                                                        </option>
                                                    )
                                                })}
                                            </React.Fragment>
                                        )
                                        // Explore Layers
                                    } else if (active === 'explore' && category === cat) {
                                        return (
                                            <option value={name} key={Math.random()}>
                                                {name}
                                            </option>
                                        )
                                    }
                                })}
                            </React.Fragment>
                        )
                    })}
                </select>
            ) : (
                ''
            )}

            {lyr.layer === 'None' ? (
                ''
            ) : (
                <div className="error-layer-header">
                    <div className="layer-pill" onClick={() => onChange('None')} title="Change Layer">
                        {lyr.layer}
                    </div>

                    <div
                        className={`remove-btn ${errorLayers.length < 2 ? 'hide' : ''}`}
                        title="Delete Layer"
                        onClick={() => removeLayer(index, lyr.layer)}
                    >
                        <span>x</span>
                    </div>
                </div>
            )}
        </div>
    )
}

LayerDropdown.propTypes = {
    categories: PropTypes.array,
    layers: PropTypes.array,
    index: PropTypes.number,
    removeLayer: PropTypes.func.isRequired,
    lyr: PropTypes.object,
    errorLayers: PropTypes.array,
    setErrorLayers: PropTypes.func,
    setSelected: PropTypes.func,
    active: PropTypes.string
}

export default LayerDropdown
